(() => {
  if (window.footyMerchBound) return;
  window.footyMerchBound = true;
  const money = text => {
    let value = (text || '').replace(/[^0-9.,]/g, '');
    const decimal = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
    if (decimal >= 0 && value.length - decimal === 3) value = value.slice(0, decimal).replace(/[.,]/g, '') + '.' + value.slice(decimal + 1);
    else value = value.replace(/[.,]/g, '');
    return Number(value);
  };
  const discount = (target, price, compare) => {
    if (!target) return;
    let badge = target.querySelector(':scope > .fo-discount-badge');
    const saving = compare > price && price > 0 ? Math.round((compare - price) / compare * 100) : 0;
    if (!saving) { badge?.remove(); return; }
    if (!badge) { badge = document.createElement('span'); badge.className = 'fo-discount-badge'; target.appendChild(badge); }
    const label = '−' + saving + ' %';
    if (badge.textContent !== label) badge.textContent = label;
    const aria = saving + ' Prozent unter dem Vergleichspreis';
    if (badge.getAttribute('aria-label') !== aria) badge.setAttribute('aria-label', aria);
  };
  const updateBadges = () => {
    document.querySelectorAll('.fh-product,.fh-pick,.fo-card,product-card').forEach(card => {
      const price = card.querySelector('.fh-product-price > span,.fo-card-price > span,[ref="priceContainer"] .price bdi');
      const compare = card.querySelector('.fh-compare-price,.fo-compare-price,[ref="priceContainer"] .compare-at-price bdi');
      discount(card.querySelector('.fh-product-media,.fh-pick-media,.fo-card-image,.card-gallery') || card, money(price?.textContent), compare && !compare.hidden ? money(compare.textContent) : 0);
    });
    const product = document.querySelector('[data-product-page]');
    if (product) {
      const price = product.querySelector('[data-product-price]');
      const compare = product.querySelector('[data-product-compare]');
      discount(product.querySelector('.fo-gallery-main'), money(price?.textContent), compare && !compare.hidden ? money(compare.textContent) : 0);
    }
  };
  const bindRails = () => {
    document.querySelectorAll('[data-fo-rail]').forEach(rail => {
      if (window.matchMedia('(min-width:1000px)').matches) {
        const capacity = Math.min(12, Math.max(4, Math.floor((rail.clientWidth + 24) / 284)));
        const count = [...rail.children].filter(card => !card.hidden).length;
        const columns = rail.hasAttribute('data-size-results') ? capacity : Math.max(1, Math.min(capacity, count || capacity));
        rail.style.setProperty('--fo-rail-columns', String(columns));
      } else {
        rail.style.removeProperty('--fo-rail-columns');
      }
      rail.tabIndex = 0;
      if (!rail.hasAttribute('aria-label')) rail.setAttribute('aria-label', 'Weitere Produkte durch Scrollen nach rechts entdecken');
    });
  };
  let scheduled = false;
  const refresh = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; updateBadges(); bindRails(); });
  };
  const initialize = () => {
    refresh();
    new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('resize', refresh);
})();
